import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AuthService } from './shared/services/auth.service';
import { TranslateService } from './shared/services/translate.service';
import { UserService } from './shared/services/user.service';
import { VersionCheckService } from './shared/services/version-check.service';
import { ApiService } from './shared/services/api.service';
import { User } from './shared/interfaces';
import { AnalyticsService } from './shared/services/analytics.service';
import { FeatureConfigService } from './shared/services/feature-config.service';
import { EmitterService } from './shared/services/emitter.service';
import { AuthUserUpdatedEvent } from './shared/models';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PlatformEventService } from './shared/services/platform-events.service';
import { GoogleAnalyticsService } from './shared/services/google-analytics.service';
import { UserflowService } from './shared/services/userflow.service';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: false,
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'app works!';
  private readonly ngUnsubscribe = new Subject<void>();

  private currentUser: User | null = null;
  constructor(
    public router: Router,
    private readonly versionCheckService: VersionCheckService,
    public authService: AuthService,
    private readonly apiService: ApiService,
    private readonly translate: TranslateService,
    public readonly userService: UserService,
    private readonly analyticsService: AnalyticsService, //to ensure its constructor is called,
    private readonly featureConfigService: FeatureConfigService,
    private readonly platformEventService: PlatformEventService,
    private readonly googleAnalyticsService: GoogleAnalyticsService,
    private readonly userflowService: UserflowService
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        let lang = event.urlAfterRedirects.split('/').pop();
        if (lang == 'fr' || lang == 'en') {
          if (lang == 'en') lang = 'en_us';

          translate.use(lang || 'en_us').then(() => {
            console.log(translate.data);
          });
        }

        // Push page view to dataLayer using GoogleAnalyticsService
        this.googleAnalyticsService.sendCustomEvent('pageView', {
          page: event.urlAfterRedirects,
          userId: this.authService.getAuthUserName(),
        });
      }
    });
  }

  ngOnInit(): void {
    if (environment.userflow.enabled) {
      this.userflowService.init();
    }
    this.currentUser = this.authService.getAuthUser();
    this.translate.use(localStorage.getItem('auth_user_language') || 'en_us').then(() => {});
    this.versionCheckService.initVersionCheck();
    this.apiService.healthCheck();
    this.featureConfigService.initializedFeatureConfig();

    EmitterService.get(AuthUserUpdatedEvent)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (user: User | null) => {
          if (this.currentUser?.username != user?.username) {
            this.currentUser = user;
            this.platformEventService.clearBannerState();
          }
        },
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
